var map = {
	"./social_icon_custom.svg": 3190,
	"./social_icon_facebook.svg": 3191,
	"./social_icon_instagram.svg": 3192,
	"./social_icon_linkedin.svg": 3193,
	"./social_icon_twitter.svg": 3194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1740;